import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import MainTopBar from '../../../../layouts/main-layout/main-top-bar/component';
import {IChangePasswordController} from '../../change-password.controller';
import {ILocalizationService} from '../../../../services/LocalizationService';

export interface ChangePasswordTopBarProps {
    controller: IChangePasswordController;
    accountLogo: string;
    localizationService: ILocalizationService;
}

interface ChangePasswordTopBarContentProps {
    controller: IChangePasswordController;
}

@observer
class ChangePasswordTopBarContent extends TechseeBaseComponent<ChangePasswordTopBarContentProps> {
    renderInternal() {
        const {controller} = this.props;

        return (
            <div className='section-container'>
                <div className='section section-box' dir={controller.dir}>
                    <div className='ts-breadcrumbs'>{controller.translate('CHANGE_PASSWORD.VIEW.CHANGE_PASSWORD')}</div>
                </div>
            </div>
        );
    }
}

@observer
export class ChangePasswordTopBar extends TechseeBaseComponent<ChangePasswordTopBarProps> {
    renderInternal() {
        const TopBarContent = () => <ChangePasswordTopBarContent controller={this.props.controller} />;

        return <MainTopBar topBarComponent={TopBarContent} accountLogo={this.props.accountLogo} />;
    }
}
